import { useHttp } from "../../common/http/httpService";

const Cache = {};

/**
 * This custom hook can be used to fetch upload categories only once from the server.
 * It mimics the behavior of the original AngularJs version of the application.
 * @returns a custom hook to use for fetching upload categories
 */
const useUploadCategoryList = () => {

  const http = useHttp();

  /**
   * @returns The list of upload categories -- from the server if this is
   * the first call, or from cache if the list has already been fetched.
   */
  const getCategories = async () => {
    if (Cache["categories"]) {
      return Cache["categories"];
    }
    const fetchedCategories = await http.get('/category');
    Cache["categories"] = fetchedCategories;
    return fetchedCategories;
  };

  return { getCategories };
};

export { useUploadCategoryList };